import React from 'react';
import { PrivateRoute } from '../core';
import { DirectoryRoutes } from './containers/DirectoryRoutes';

export const routes = [<PrivateRoute path="/directory" key="route--directory" component={DirectoryRoutes} />];
